// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3C5Ma","list":"BalanceDue_list__3FBa8","listRow":"BalanceDue_listRow__ra_ce","total":"BalanceDue_total__3T8MQ"};